import Emitter from './Emitter'

import store from '../store'

import debounce from 'lodash.debounce'

import { bindAll } from '../utils'

class Resize {
  constructor() {
    bindAll(this, 'resize')

    this.init()
  }

  resize() {
    let w = window.innerWidth
    let h = store.sniffer.isDevice ? window.outerHeight : window.innerHeight

    store.bounds.ww = w
    store.bounds.wh = h

    if (store.sniffer.isDevice && store.bounds.ww === window.innerWidth) return

    Emitter.emit('resize', { width: w, height: h })
  }

  on() {
    window.addEventListener('resize', debounce(this.resize, 200))
  }

  init() {
    this.on()
  }
}

export default new Resize()